<div [ngClass]="{ 'grayOverlay': grayOut }">
  <p-card class="bucket-card" [ngClass]="{'crew-invalid': bucketErrors.length > 0 }">
    <p-header>
      {{bucketTitle}}

      @if (bucketErrors.length > 0) {
      <div style="float: right;">
        <i class="pi pi-exclamation-triangle" (mouseenter)="errorPanel.toggle($event)"
          (mouseleave)="errorPanel.toggle($event)" (click)="errorPanel.toggle($event)"></i>
        <p-popover #errorPanel [appendTo]="'body'">
          @for (error of bucketErrors; track error) {
          <div>
            {{error}}
          </div>
          }
        </p-popover>
      </div>
      }
    </p-header>

    {{employeeList}}

    <div class="toggle-tasks">
      @if (isCollapsed) {
      <div>
        <span (click)="isCollapsed = !isCollapsed" [attr.aria-expanded]="!isCollapsed" class="plus-minus-span"> +
        </span>
      </div>
      }
      @if (!isCollapsed) {
      <div>
        <span (click)="isCollapsed = !isCollapsed" [attr.aria-expanded]="!isCollapsed" class="plus-minus-span"> -
        </span>
      </div>
      }
      <div [ngbCollapse]="isCollapsed" class="crew-work-orders">
        <div [id]="'bucketEquipmentList-' + bucket.id" [cdkDropListData]="bucket.scheduledBucketEquipment"
          [cdkDropListConnectedTo]="dragAndDropService.allCDKEquipmentListIds" cdkDropList [cdkDropListDisabled]="!canDrag"
          (cdkDropListDropped)="drop($event)">
          @if (bucket.scheduledBucketEquipment) {
          <span>Equipment</span>
          }
          @for (bucketEquipment of bucket.scheduledBucketEquipment; track bucketEquipment.equipmentId) {
          <div class="inner-card" cdkDrag (cdkDragStarted)="dragStart($event)">
            <app-equipment-card [equipment]="bucketEquipment.equipment" [deleteable]="canDrag"
              (deleted)="deleteEquipmentFromBucket($event)"></app-equipment-card>
          </div>
          }
          @if (bucket.scheduledBucketEquipment.length == 0) {
          <div class="inner-card drag-placeholder">
            <p-card>Drag Equipment Here</p-card>
          </div>
          }
        </div>
        <div [id]="'bucketEmployeeList-' + bucket.id" cdkDropList [cdkDropListData]="bucket.scheduledBucketEmployees" [cdkDropListDisabled]="!canDrag"
          [cdkDropListConnectedTo]="dragAndDropService.allCDKEmployeeListIds" (cdkDropListDropped)="drop($event)">
          @if (bucket.scheduledBucketEmployees) {
          <span>Employees</span>
          }
          @for (bucketEmployee of bucket.scheduledBucketEmployees; track bucketEmployee.employeeId) {
          <div class="inner-card" (cdkDragStarted)="dragStart($event)" cdkDrag>
            <app-employee-card [employee]="bucketEmployee.employee" [deleteable]="canDrag"
              (deleted)="deleteEmployeeFromBucket($event)"></app-employee-card>
          </div>
          }
          @if (bucket.scheduledBucketEmployees.length == 0) {
          <div class="inner-card drag-placeholder">
            <p-card>Drag Person Here</p-card>
          </div>
          }
        </div>
        <span>Work Orders</span>
        @if (isWellness) {
        <div [id]="'bucketWorkOrderList-' + bucket.id" style="padding-bottom: 5px;" cdkDropList [cdkDropListDisabled]="!canDrag"
          [cdkDropListData]="bucket.scheduledBucketWellnessWorkOrders"
          [cdkDropListConnectedTo]="dragAndDropService.allCDKWorkOrderListIds" (cdkDropListDropped)="drop($event)">
          @for (bucketWorkOrder of bucket.scheduledBucketWellnessWorkOrders; track bucketWorkOrder.wellnessWorkOrderId) {
          <div class="inner-card" (cdkDragStarted)="dragStart(bucketWorkOrder.wellnessWorkOrder)" cdkDrag
            (cdkDragEnded)="dragWOEnd()" (cdkDragEnded)="dragWOEnd()" [cdkDragDisabled]="disableDrag(bucketWorkOrder)">
            <app-scheduled-bucket-wellness-work-order-card [showScheduled]="true" [bucket]="bucket" [canDrag]="canDrag"
              [bucketId]="bucket.id" [workOrder]="bucketWorkOrder.wellnessWorkOrder"
              (dragStartEvent)="dragStart($event)"
              (taskDragEndEvent)="taskDragEnd()"></app-scheduled-bucket-wellness-work-order-card>
          </div>
          }
          @if (bucket.scheduledBucketWellnessWorkOrders.length == 0) {
          <div class="inner-card drag-placeholder">
            <p-card>Drag Work Order Here</p-card>
          </div>
          }
        </div>
        }

        @if (isWork) {
        <div [id]="'bucketWorkOrderList-' + bucket.id" style="padding-bottom: 5px;" cdkDropList [cdkDropListDisabled]="!canDrag"
          [cdkDropListData]="bucket.scheduledBucketWorkWorkOrders"
          [cdkDropListConnectedTo]="dragAndDropService.allCDKWorkOrderListIds" (cdkDropListDropped)="drop($event)">
          @for (bucketWorkOrder of bucket.scheduledBucketWorkWorkOrders; track bucketWorkOrder.workWorkOrderId) {
          <div class="inner-card" (cdkDragStarted)="dragStart(bucketWorkOrder.workWorkOrder)" cdkDrag
            (cdkDragEnded)="dragWOEnd()" [cdkDragDisabled]="disableDrag(bucketWorkOrder)">
            <app-scheduled-bucket-work-work-order-card [showScheduled]="true" [bucket]="bucket" [bucketId]="bucket.id" [canDrag]="canDrag"
              [workOrder]="bucketWorkOrder.workWorkOrder" (dragStartEvent)="dragStart($event)"
              (taskDragEndEvent)="taskDragEnd()"></app-scheduled-bucket-work-work-order-card>
          </div>
          }
          @if (bucket.scheduledBucketWorkWorkOrders.length == 0) {
          <div class="inner-card drag-placeholder">
            <p-card>Drag Work Order Here</p-card>
          </div>
          }
        </div>
        }
      </div>
    </div>
    &nbsp;
    <ngb-progressbar [type]="type" [value]="hours" height="20px">{{taskHours}} / {{totalHours}} Hrs</ngb-progressbar>
  </p-card>
</div>